import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=b2687d2c&scoped=true"
import script from "./SalesOrder.vue?vue&type=script&lang=ts"
export * from "./SalesOrder.vue?vue&type=script&lang=ts"
import style0 from "./SalesOrder.vue?vue&type=style&index=0&id=b2687d2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2687d2c",
  null
  
)

export default component.exports